import React from 'react';
import { termsConfig } from '../../../config/terms.config.js';
export const legalEntityAgreementContent = {
  title: "об использовании материалов и сервисов интернет-сайта https://svetofore.com/",
  text: termsConfig.agreement_material_services_text,
  checkboxText: "Я принимаю условия пользовательского соглашения",
};
